/**
 * The Suppressed tab of Do-not-contact (`contacts.suppressed`, PREC-4266): a workspace's
 * suppressed email addresses and the removal of one. Each reason has its own key
 * (`reasons.<REASON>`), looked up from a closed map, never interpolated.
 */
export const enEmailSuppression = {
	nameColumn: "Name",
	companyColumn: "Company",
	reasonColumn: "Suppressed reason",
	suppressedOnColumn: "Suppressed on",
	removeColumn: "Remove",
	removeAction: "Remove",
	reasons: {
		HARD_BOUNCE: "Hard bounce",
		PROVIDER_BLOCK: "Provider block",
	},
	reasonWithCode: "{{reason}} · {{code}}",
	empty: "No suppressed addresses. Addresses that hard-bounce are listed here.",
	removeTitle: "Remove from Suppressed",
	removeConfirmation:
		"Remove {{email}} from Suppressed? Signalist can email this address again in this workspace's campaigns.",
	removed: "{{email}} was removed from Suppressed. This workspace's campaigns can email it again.",
	removeFailed: "{{email}} could not be removed from Suppressed. Please try again.",
};
